import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '../../common/constants';
import { isEmptyArray } from '../../common/util.services';
import './production-process-list.component.scss';
import { getProcess, deleteProcess } from '../production.services';

const ProductionProcessList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [role, setRole] = useState<String>('USER');
  const [processData, setProcessData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'processCode', headerName: 'Process Code', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'process', headerName: 'Process Name', filterable: false, sortable: false, editable: false, width: 550 },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 550 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (appContext.userData) {
      setRole(appContext.userData.role);
    }
    if (isEmptyArray(rows)) {
      getProcess(page, pageSize, appContext,
        (response: any) => {
          setProcessData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const handleEditAction = (row: any) => {
      navigate(EMPTY_STRING + row.rowId);
  }

  const handleDeleteAction = (row: any) => {
      deleteProcess(row.rowId, appContext,
        (response: any) => {
          setProcessData(processData.filter((r) => r.rowId !== row.rowId));
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
  };
  
  const addProcess = () => {
      navigate('new');
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={processData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} 
        showAction={'ADMIN' === role || 'LFHADMIN' === role} showAddBtn={'ADMIN' === role || 'LFHADMIN' === role} 
        showApproveAction={false} showDeleteAction={true} maxHeight={450}
        showUpAction={false} showDownAction={false} handleEditAction={handleEditAction}
        getRowId={(row: any) => row.rowId} addRow={addProcess} handleDeleteAction={handleDeleteAction}/>
    </>
  }

  return <TitlePanel title='Production Process' panelBody={getMainPanel()} />
}

export default ProductionProcessList;